module.exports = __webpack_public_path__ + "media/images/about-us/pc-c73e4288d49946ac9e9947b04a6ee4be.jpeg";